import React, { useState, useContext } from 'react'

const RootContext = React.createContext()

export const initialState = {
  // currently logged in user
  currentUser: null,
  // Builder project data
  project: null,
  // AEP instance details
  aep: null,
  // Direct Route for profile lookup
  dr: null,
  
  showRibbon: null
}

// Provider component which will be used to wrap a group of components in order to pass context variables
const RootContextProvider = (props) => {
  const [state, setState] = useState(initialState)

  const value = { ...state, setRootState: setState }

  return <RootContext.Provider value={value}>{props.children}</RootContext.Provider>
}

function useRootContext() {
  const rootContext = useContext(RootContext)

  return rootContext || {}
}

export { RootContext, RootContextProvider, useRootContext }
